import DataObject from './DataObject';

export default class UserActionEventObject extends DataObject {
  constructor(data) {
    super('uaevent', data);
    this.result.ecommerce = undefined;
  }

  set category(category) {
    this.result.eventCategory = this.setProperty(category);
  }

  get category() {
    return this.result.eventCategory;
  }

  set action(action) {
    this.result.eventAction = this.setProperty(action);
  }

  get action() {
    return this.result.eventAction;
  }

  set label(label) {
    this.result.eventLabel = this.setProperty(label);
  }

  get label() {
    return this.result.eventLabel;
  }

  set name(name) {
    this.result.event_name = this.setProperty(name);
  }

  get name() {
    return this.result.event_name;
  }

  set articlename(articlename) {
    this.result.article_name = this.setProperty(articlename);
  }

  get articlename() {
    return this.result.article_name;
  }

  set menu_type(menu_type) {
    this.result.menu_type = this.setProperty(menu_type);
  }

  get menu_type() {
    return this.result.menu_type;
  }

  set bread_crumb(bread_crumb) {
    this.result.bread_crumb = this.setProperty(bread_crumb);
  }

  get bread_crumb() {
    return this.result.bread_crumb;
  }

  set click_area(click_area) {
    this.result.click_area = this.setProperty(click_area);
  }

  get click_area() {
    return this.result.click_area;
  }
  set event_detail(event_detail) {
    this.result.event_detail = this.setProperty(event_detail);
  }

  get event_detail() {
    return this.result.event_detail;
  }

  set author(author) {
    this.result.article_author = this.setProperty(author);
  }

  get author() {
    return this.result.article_author;
  }

  set details(details) {
    this.result.event_detail = this.setProperty(details);
  }

  get details() {
    return this.result.event_detail;
  }

  set filter(filter) {
    this.result.filter_value = this.setProperty(filter);
  }

  get filter() {
    return this.result.filter_value;
  }

  set categoryname(categoryname) {
    this.result.cta_name = this.setProperty(categoryname);
  }

  get categoryname() {
    return this.result.cta_name;
  }

  set glossary_cat_name(glossary_cat_name) {
    this.result.cta_name = this.setProperty(glossary_cat_name);
  }

  get glossary_cat_name() {
    return this.result.cta_name;
  }

  set click_action(click_action) {
    this.result.click_action = this.setProperty(click_action);
  }

  get click_action() {
    return this.result.click_action;
  }

  set socialaction(socialaction) {
    this.result.social_action = this.setProperty(socialaction);
  }

  get socialaction() {
    return this.result.social_action;
  }

  set socialnetwork(socialnetwork) {
    this.result.social_network = this.setProperty(socialnetwork);
  }

  get socialnetwork() {
    return this.result.social_network;
  }

  set event_name(event_name) {
    this.result.event_name = this.setProperty(event_name);
  }

  get event_name() {
    return this.result.event_name;
  }

  set video_info(video_info) {
    this.result.video_info = this.setProperty(video_info);
  }

  get video_info() {
    return this.result.video_info;
  }

  set referral(referral) {
    this.result.referral = this.setProperty(referral);
  }

  get referral() {
    return this.result.referral;
  }

  set referral(referral) {
    this.result.referral = this.setProperty(referral);
  }

  get referral() {
    return this.result.referral;
  }

  set brand_info(brand_info) {
    this.result.brand_info = this.setProperty(brand_info);
  }

  get brand_info() {
    return this.result.brand_info;
  }

  set value(value) {
    this.result.eventValue = this.setProperty(value);
  }
}
